import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import api from '../utils/api';
import { API_URL } from '../components/config';
import HarvestingTopNav from '../components/HarvestingTopNav';
import { getViewAsMode } from '../utils/viewMode';
import './HarvestingBlogPage.css';

const HarvestingBlogPostPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const viewAsMode = getViewAsMode(location.search);
  const previewMode = Boolean(viewAsMode);
  const previewQuery = viewAsMode ? `?viewAs=${viewAsMode}` : '';

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = previewMode
          ? await axios.get(`${API_URL}/api/harvesting-posts/public/${id}`)
          : await api.get(`/api/harvesting-posts/public/${id}`);
        setPost(response.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Error fetching post');
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
  }, [id, previewMode]);

  return (
    <div className="harvesting-blog-page">
      <HarvestingTopNav />

      <div className="blog-header">
        <Link to={`/harvesting/blog${previewQuery}`} className="back-link">← Back to Blog</Link>
        {post && (
          <>
            <h1>{post.title}</h1>
            <p className="post-date">
              {new Date(post.publishDate).toLocaleDateString('en-US', {
                timeZone: 'America/Toronto',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })}
            </p>
          </>
        )}
      </div>

      {loading ? (
        <div className="loading">Loading post...</div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : post ? (
        <div className="blog-post-detail">
          {post.imageUrl && (
            <div className="blog-post-hero">
              <img src={post.imageUrl} alt={post.title} />
            </div>
          )}
          <div
            className="blog-post-body"
            dangerouslySetInnerHTML={{ __html: post.content || '' }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default HarvestingBlogPostPage;
